import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private http: HttpClient) { }

  public GetLocationsByRegion() {
    return this.http.get(window.location.origin + '/api/locations/region');
  }

  public GetLocationsCount(countGroup: string) {
    return this.http.get(window.location.origin + '/api/locations/count/' + countGroup);
  }

  public GetLocationStateCount(countGroup: string) {
    return this.http.get(window.location.origin + '/api/locations/statecount/' + countGroup);
  }

  public GetLocationDetails(locationId: any, language: any) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json; charset=utf-8');

    const params = new HttpParams().set('language', language);

    return this.http.get(window.location.origin + '/api/locations/' + locationId, { headers, params });
  }

  public GetLocationsWithActiveEquipment() {
    return this.http.get(window.location.origin + '/api/locations/activeequipment');
  }

  public GetLocationLang(lang = 'eng') {

    if (lang === 'es') {
      return this.http.get(window.location.origin + '/assets/language/location.es.json');
    }
    else {
      return this.http.get(window.location.origin + '/assets/language/location.eng.json');
    }
  }

  public GetLocationDetailsLang(lang = 'eng') {
    if (lang === 'es') {
      return this.http.get(window.location.origin + '/assets/language/location-details.es.json');
    }
    else {
      return this.http.get(window.location.origin + '/assets/language/location-details.eng.json');
    }
  }

}
